/*
*
* File JS componente SLIDER AUTHORS
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css/bundle';
import Swiper, { Navigation, Pagination, Grid } from 'swiper';
Swiper.use([Navigation, Pagination, Grid]);

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './slider-authors.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const sliderAuthors = () => {
    let allSlidersAuthors = document.querySelectorAll('.slider-authors');
    
    if(!allSlidersAuthors.length) return;

    let allSwipers = [];
    let initialized = false;

    const initSwipers = () => {
        allSlidersAuthors.forEach((el, i) => {
            let args = {
                breakpoints: {
                    0: {
                        grid: {
                            fill: 'rows',
                            rows: 5,
                        },
                    },
                    768: {
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                    },
                    1024: {
                        slidesPerView: 5,
                        slidesPerGroup: 5,
                    }
                },
                pagination: {
                    el: el.querySelector('.swiper-pagination'),
                    type: 'bullets',
                },
                navigation: {
                    nextEl: el.querySelector('.swiper-button-next'),
                    prevEl: el.querySelector('.swiper-button-prev'),
                },
                a11y: {
                    enabled: true,
                    prevSlideMessage: 'Previous slide',
                    nextSlideMessage: 'Next slide',
                    firstSlideMessage: 'This is the first slide',
                    lastSlideMessage: 'This is the last slide',
                    paginationBulletMessage: 'Go to slide {{index}}',
                    notificationClass: 'swiper-notification'
                },
            };
        
            allSwipers[i] = new Swiper(el.querySelector('.swiper-container'), args);
        });

        initialized = true;
    };

    initSwipers();

    window.addEventListener('resize', () => {
        allSwipers.forEach(el => {
            el.destroy();
        });

        initialized = false;

        initSwipers();
    });
}

export default sliderAuthors;

//--------------------------------------------------------------------//